import { lawyerPositionsApi } from '@shared/api/lawyer-positions';
import type { LawyerPosition } from '@shared/types/lawyer-position';

/// 役職マスタを「選択肢」用に全件ロードするストア。
///
/// 弁護士の作成モーダル (`LawyerCreateModal`) と詳細編集 (`LawyerDetail`) が役職 select
/// の候補に使う。役職は Lawyer 本体とは別カタログ (`lawyers.position` が name を FK 参照)
/// なので、`lawyer` entity ではなく独立した slice として持つ。
///
/// `/api/lawyer-positions` は業務非依存の generic カタログで、`lawyerPositionsApi` が
/// 既に typed (`LawyerPositionList`) を返すため、domain parser は通さず typed のまま保持する
/// (#475 の parse-don't-validate は業務モデルに適用する方針で、本カタログは対象外)。
interface OptionsState {
  data: LawyerPosition[];
  loading: boolean;
  error: string | null;
}

const optionsState = $state<OptionsState>({ data: [], loading: false, error: null });
let optionsToken = 0;

export const lawyerPositionOptionsStore = {
  get data(): LawyerPosition[] {
    return optionsState.data;
  },
  get loading(): boolean {
    return optionsState.loading;
  },
  get error(): string | null {
    return optionsState.error;
  },
  /// 役職マスタを全件ロードする。stale は token で破棄。
  async load(): Promise<void> {
    const token = ++optionsToken;
    optionsState.loading = true;
    optionsState.error = null;
    try {
      const res = await lawyerPositionsApi.list();
      if (token !== optionsToken) return;
      optionsState.data = res.items;
    } catch (err) {
      if (token !== optionsToken) return;
      optionsState.error = err instanceof Error ? err.message : String(err);
    } finally {
      if (token === optionsToken) optionsState.loading = false;
    }
  },
  clear(): void {
    optionsToken++;
    optionsState.data = [];
    optionsState.loading = false;
    optionsState.error = null;
  },
};
